import { createSlice } from '@reduxjs/toolkit';

export const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    session: null
  },
  reducers: {
    saveSession: (state, action) => {
      const { payload } = action;
      state.session = { ...state.session, ...payload };
    },
    clearSession: (state) => {
      state.session.access = null;
    },
    clearNotificaciones: (state) => {
      state.session.notificaciones = 0;
    }
  }
});

export const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    open: false,
    showLayout: true,
    sideBarComponent: true
  },
  reducers: {
    open: (state) => {
      state.open = !state.open;
    },
    showLayout: (state, action) => {
      const { payload } = action;
      state.showLayout = payload;
    },
    showSideBar: (state, action) => {
      const { payload } = action;
      state.sideBarComponent = payload;
    }
  }
});

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    show: false
  },
  reducers: {
    showModal: (state) => {
      state.show = !state.show;
    }
  }
});

export const prospectoSlice = createSlice({
  name: 'prospecto',
  initialState: {
    id: {}
  },
  reducers: {
    setId: (state, action) => {
      const { payload } = action;
      state.id = { ...payload };
    },
    clearId: (state) => {
      state.id = {};
    }
  }
});

export const detalleSlice = createSlice({
  name: 'detalle',
  initialState: {
    id: {},
    expediente: {},
    firma: {}
  },
  reducers: {
    setIdExpediente: (state, action) => {
      const { payload } = action;
      state.id = { ...payload };
    },
    setExpediente: (state, action) => {
      const { payload } = action;
      state.expediente = { ...payload };
    },
    setFirma: (state, action) => {
      const { payload } = action;
      state.firma = { ...payload };
    },
    clearIdExpediente: (state) => {
      state.id = {};
    }
  }
});

export const expedienteSlice = createSlice({
  name: 'expediente',
  initialState: {
    expediente: {}
  },
  reducers: {
    setExpedienteId: (state, action) => {
      const { payload } = action;
      state.expediente.id = payload;
    },
    setExpedienteData: (state, action) => {
      const { payload } = action;
      state.expediente = { ...payload };
    }
  }
});

const mapTelefonos = (telefonos, payload) => {
  return telefonos.map((phone) => {
    if (phone.idOrigin === payload.idOrigin) {
      return { ...phone, valido: payload.valido };
    }
    return phone;
  });
};
export const telefonosSlice = createSlice({
  name: 'telefonos',
  initialState: {
    telefonos: {
      aval: [],
      cliente: []
    }
  },
  reducers: {
    setTelefonos: (state, action) => {
      const { payload } = action;
      state.telefonos = { ...state.telefonos, ...payload };
    },
    activePhone: (state, action) => {
      const { payload } = action;
      const telefonosAval = mapTelefonos(state.telefonos?.aval, payload);
      const telefonosCliente = mapTelefonos(state.telefonos?.cliente, payload);
      state.telefonos.aval = telefonosAval;
      state.telefonos.cliente = telefonosCliente;
    }
  }
});
export const OdpSlice = createSlice({
  name: 'odp',
  initialState: {
    odp: {}
  },
  reducers: {
    setOdp: (state, action) => {
      const { payload } = action;
      state.odp = payload;
    },
    clearOdp: (state) => {
      state.odp = {};
    }
  }
});
export const notificacionSlice = createSlice({
  name: 'notificacion',
  initialState: {
    notificacion: {}
  },
  reducers: {
    setNotificacion: (state, action) => {
      const { payload } = action;
      state.notificacion = payload;
    },
    clearItem: (state) => {
      state.notificacion = {};
    }
  }
});

export const pagosSlice = createSlice({
  name: 'pagos',
  initialState: {
    pagos: {
      rows: [],
      totalDepositos: 0,
      faltante: 0,
      montoTotal: 0
    }
  },
  reducers: {
    setPagos: (state, action) => {
      const { payload } = action;
      state.pagos = payload;
    },
    clearPagos: (state) => {
      state.pagos = {
        rows: [],
        totalDepositos: 0,
        faltante: 0,
        montoTotal: 0
      };
    }
  }
});

export const { saveSession, clearSession, clearNotificaciones } = sessionSlice.actions;
export const { open, showLayout, showSideBar } = menuSlice.actions;
export const { showModal } = modalSlice.actions;
export const { setId, clearId } = prospectoSlice.actions;
export const { setIdExpediente, clearIdExpediente, setExpediente, setFirma } = detalleSlice.actions;
export const { setExpedienteId, setExpedienteData } = expedienteSlice.actions;
export const { activePhone, setTelefonos } = telefonosSlice.actions;
export const { setOdp, clearOdp } = OdpSlice.actions;
export const { setNotificacion, clearItem } = notificacionSlice.actions;
export const { setPagos, clearPagos } = pagosSlice.actions;
